<app-loading-indicator #indicator>
  <div class="screen-loading" [class.hidden]="!indicator.pleaseWait">
    <div class="screen-loading-spinner"></div>
  </div>
</app-loading-indicator>
<rtn-alert #appAlert></rtn-alert>
<rtn-alert-timeout #appAlertTimeout></rtn-alert-timeout>
<router-outlet></router-outlet>
